import styled from '@emotion/styled/macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const UserInputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  border-bottom: 2px solid #989898;
`

export const UserInputWrapper = styled.div`
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  background: #f5f5f5;
  border-radius: 4px 4px 0 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const InputWrapper = styled.div`
  background: #f5f5f5;
  border-radius: 4px 4px 0 0;
  display: inline-block;
  position: relative;
  width: 100%;
`

export const UserInputIcon = styled(FontAwesomeIcon)`
  color: #989898;
  min-width: 50px;
  padding: 9px 0;
  position: absolute;
  text-align: center;
`

export const UserInput = styled.input`
  background-color: transparent;
  border: none;
  box-sizing: border-box;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.25px;
  outline: none;
  padding: 8px 48px;
  width: 100%;
  &:focus + .underline {
    width: 100%;
  }
`

export const UserInputUnderline = styled.span`
  position: absolute;
  bottom: 0;

  // to center the animation
  left: 50%;
  transform: translateX(-50%);

  height: 2px;
  width: 0;
  background-color: #005cd9;
  transition: 0.5s;
`

export const UserInputCancelSpan = styled.span``

export const UserInputCancelIcon = styled(FontAwesomeIcon)<{
  isRender: boolean
}>`
  color: #989898;
  min-width: 50px;
  padding-top: 9px;
  text-align: center;
  display: ${({ isRender }) => (isRender ? 'block' : 'none')};

  &:hover {
    color: #3c4043;
    cursor: pointer;
  }
`
